import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import Gem from "./Gem";
import ABCyaLib from "@abcya/abcya_lib";

export default class GemArea extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);
        this.name = "Gem Area";
        gameData.SPECIAL_GEM = false;

        this.maxGemsPerCol = 8;
        this.gemSizeHeight = 88;
        this.gemSizeWidth = 88;
        this.gemSpacing = 0;
        this.soundInd = 0;
        this.gemsToAdj = 0;
        this.adjInd = 0;

        this.gems = [];
        this.allGems = [];
        this.moves = [];
        this.clusters = [];
        this.lineArr = [];
        this.circleArr = [];

        this.level = {
            x: this.gemSizeWidth/1.25,
            y: this.gemSizeHeight*2 - this.gemSpacing*3,
            columns: 8,
            rows: 8,
            tilewidth: this.gemSizeWidth,
            tileheight: this.gemSizeHeight,
            gems: [],
            selectedtile: { selected: false, column: 0, row: 0 }
        };

        this.cont = this.scene.add.container();
        this.lineTopCont = this.scene.add.container();
        this.lineBotCont = this.scene.add.container();
        this.add([this.cont, this.lineBotCont, this.lineTopCont]);
		
        this.createLevel();

        this.on("pointerdown", (pointer)=>{ this.grab(pointer); });
        this.on("pointermove", (pointer, x, y)=>{ this.move(pointer, x, y); });
        this.on("pointerup", (pointer)=>{ this.release(pointer); });
    }

    setUI(uiFlag){
        console.log("setting UI " + uiFlag);
        if(uiFlag == true){
            if(!gameData.GAME_PAUSED && !gameData.GAME_DONE){
                this.scene.navBar.toggleTimer("on");
                this.scene.navBar.setListeners("on");

                this.setSize(1536, 2048);
                if(!this.input) this.setInteractive();
                else if(this.input && !this.input.enabled) this.setInteractive();
            }
        }else{
            //console.log("turning off");
            this.disableInteractive();
        }
    };

    createLevel() {
        console.log("level = " + gameData.GAME_LEVEL);
        gameData.GAME_DONE = false;
        gameData.GRABBING = false;

        if(this.allGems.length > 0){
            this.allGems.forEach(gem => {
                gem.removeAll(true);
                gem.destroy();
                gem = null;
            });
        }

        this.gems = [];
        this.allGems = [];
        this.moves = [];
        this.clusters = [];
        this.lineArr = [];
        this.circleArr = [];

        for(let g = 0; g < this.maxGemsPerCol; g++){
            let col = this.createCol(g);
            this.gems.push(col);
        }

        for(let i = 0; i < this.allGems.length; i++){
            this.allGems[i].randInd = i;
        }

        this.cont.y = -this.scene.mid.y - 225;

        if(gameData.GAME_LEVEL == 0){
            this.instructionsCont = this.scene.add.container();
            this.instructions = ABCyaPhaser.Images.addImage(0, 0, "InstructionsPopup", this.instructionsCont);
            this.hand = ABCyaPhaser.Images.addImage(0, 0, "InstructionsHand", this.scene);
            this.instPrompt = ABCyaPhaser.Text.addText(-150, -47, 37, "0xFFFFFF", gameData.GAME_FONTS[0],"Drag across gems\nwith the same number.", this.instructionsCont, false);

            this.bgShade = ABCyaPhaser.Graphics.addRect(0, 0, this.scene.mid.x*2, this.scene.mid.y*2, "0x000000", this.cont, {x:0, y:0}).setAlpha(0);

            for(let a = 26; a < 31; a++) {
                this.allGems[a].changeSpecial(6); 
                this.cont.moveAbove(this.allGems[a], this.bgShade);
            }

            this.instructionsCont.x = this.scene.mid.x;
            this.instructionsCont.y = 220;
            this.hand.x = this.allGems[26].x + 10;
            this.hand.y = this.allGems[26].y + 60;
            this.instructionsCont.scaleX = this.instructionsCont.scaleY = 0;
            this.hand.scaleX = this.hand.scaleY = 0;

            this.instructionsCont.setDepth(5);
            this.hand.setDepth(6);

            ABCyaPhaser.Tweens.addTween(this.cont, 1250, {y:0}, Phaser.Math.Easing.Cubic.In, ()=>{ this.createInstructions(); });
        } else {
            this.handTween?.stop();
            this.dCall?.destroy();

            ABCyaPhaser.Tweens.addTween(this.cont, 1250, {y:0}, Phaser.Math.Easing.Cubic.In, ()=>{ this.playSound(); });
        }
    };

    createInstructions(){
        this.stopTimerDelayedCall = this.scene.time.delayedCall(20000, ()=>{console.log("stopping timer"); this.scene.navBar.toggleTimer("off");});
        ABCyaPhaser.Tweens.addTween(this.bgShade, 500, {alpha:.75}, Phaser.Math.Easing.Linear);
    };

    startInstructions(){
        this.setUI(true);
        if(this.instructionsCont) ABCyaPhaser.Tweens.addTween(this.instructionsCont, 500, {scale:1}, Phaser.Math.Easing.Back.Out); 
        if(this.hand) ABCyaPhaser.Tweens.addTween(this.hand, 500, {scale:1}, Phaser.Math.Easing.Back.Out, ()=>{this.playInstructions();}); 
    };
    
    playInstructions(){
        //console.log("playing");
        this.hand.alpha = 1;
        this.hand.y = this.allGems[26].y + 60;
        this.hand.x = this.allGems[26].x + 10;
        this.hand.angle = 0;
        
        this.handTween = ABCyaPhaser.Tweens.addTween(this.hand, 2000, {delay:250, y:this.allGems[31].y - 20, repeat:-1, repeatDelay:500}, Phaser.Math.Easing.Linear);
    };

    moveHand(type) {
        this.handTween?.stop();
        this.dCall?.destroy();
        if(this.hand) this.scene.tweens.killTweensOf(this.hand);

        if (type == "answer") {
            gameData.INTRO_STEP = 1;
            //console.log("moving hand");
            this.hand.alpha = 1;
            this.hand.scaleX = this.hand.scaleY = 1;
            this.hand.x = this.scene.mid.x + 30;
            this.hand.y = 770;
            this.scene.gemArea.hand.angle = 180;

            this.instPrompt.text = "Press the correct\nanswer to score gems.";

            this.scene.time.delayedCall(500, ()=>{this.moveHand("answerMove");});
        }
        if (type == "answerMove") {
            this.handTween = this.scene.tweens.timeline({
                targets: this.hand,
                ease:Phaser.Math.Easing.Linear,
                duration:1500,
                loop:-1,

                tweens: [
                    {delay:250, x:this.scene.mid.x + 280},
                    {delay:250, x:this.scene.mid.x + 30},
                ]
            });
        }

        if (type == "special") {
            this.instPrompt.text = "Five or more gems will\ngive you a special item.";
            gameData.INTRO_STEP = 2;

            this.hand.alpha = 1;
            this.hand.x = this.allGems[43].x;
            this.hand.y = this.allGems[43].y + this.hand.height - 20;
            this.scene.gemArea.hand.angle = 0;

            this.allGems[43].changeSpecial(Phaser.Math.Between(97, 99));
            this.cont.moveTo(this.allGems[43], this.cont.list.length-1);

            this.moveHand("specialMove");
        }
        if (type == "specialMove") {
            this.handTween = this.scene.tweens.timeline({
                targets: this.hand,
                ease:Phaser.Math.Easing.Linear,
                duration:1500,
                loop:-1,

                tweens: [
                    {y: this.allGems[43].y + this.hand.height + 50},
                    {y: this.allGems[43].y + this.hand.height - 20},
                ]
            });
        }

        if (type == "score") {
            this.setUI(true);
            this.instPrompt.text = "Collect enough gems to\nmove to the next stage.";
            gameData.INTRO_STEP = 3;

            this.hand.x = 675;
            this.hand.y = 175;
            this.hand.alpha = 1;

            this.instructionsCont.y = 400;

            this.cont.moveTo(this.allGems[43], 5);

            this.moveHand("scoreMove");

        }
        if (type == "scoreMove") {
            this.handTween = this.scene.tweens.timeline({
                targets: this.hand,
                ease:Phaser.Math.Easing.Linear,
                duration:1500,
                onComplete:()=>{this.moveHand("points");},

                tweens: [
                    {y: 225},
                    {y: 175},
                    {y: 225},
                    {y: 175},
                ]
            });
        }

        if (type == "points") {
            this.instPrompt.text = "Correct answers will\ngive you points.";
            gameData.INTRO_STEP = 4;

            this.hand.x = 500;
            this.hand.y = 175;

            this.moveHand("pointsMove");

        }
        if (type == "pointsMove") {
            this.handTween = this.scene.tweens.timeline({
                targets: this.hand,
                ease:Phaser.Math.Easing.Linear,
                duration:1500,
                onComplete:()=>{this.moveHand("timer");},

                tweens: [
                    {y: 225},
                    {y: 175},
                    {y: 225},
                    {y: 175},
                ]
            });
        }

        if (type == "timer") {
            this.instPrompt.text = "Be careful not to\nrun out of time!";
            gameData.INTRO_STEP = 5;

            this.hand.x = 300;
            this.hand.y = 175;

            this.moveHand("timerMove");

        }
        if (type == "timerMove") {
            this.handTween = this.scene.tweens.timeline({
                targets: this.hand,
                ease:Phaser.Math.Easing.Linear,
                duration:1500,
                onComplete:()=>{this.destroyLevel(true);},

                tweens: [
                    {y: 225},
                    {y: 175},
                    {y: 225},
                    {y: 175},
                ]
            });
        }
    };
    toggleHand(type){
        type ? this.handTween?.resume() : this.handTween?.pause();
    };

    createCol(ind){
        //console.log("creating column");
        let randGem;
        let col = [];
        let colXStart = this.gemSizeWidth/1.25;
        let colYStart = this.gemSizeHeight*2 - this.gemSpacing*3;

        for(let g = 0; g < this.maxGemsPerCol; g++) {
            if(gameData.GAME_LEVEL == 0 || gameData.GAME_LEVEL == 1){
                randGem = Phaser.Math.Between(1,5);
            }
            if(gameData.GAME_LEVEL == 2){
                randGem = Phaser.Math.Between(2,6);
            }
            if(gameData.GAME_LEVEL == 3){
                randGem = Phaser.Math.Between(3,7);
            }
            if(gameData.GAME_LEVEL == 4){
                randGem = Phaser.Math.Between(4,8);
            }
            if(gameData.GAME_LEVEL == 5){
                randGem = Phaser.Math.Between(5,9);
            }
            if(gameData.GAME_LEVEL == 6){
                randGem = Phaser.Math.Between(6,10);
            }
            if(gameData.GAME_LEVEL == 7){
                randGem = Phaser.Math.Between(7,11);
            }
            if(gameData.GAME_LEVEL == 8){
                randGem = Phaser.Math.Between(8,12);
            }
            let gem = new Gem(this.scene, this.cont, randGem);

            gem.x = (ind == 0) ? colXStart : colXStart + (this.gemSizeWidth + this.gemSpacing)*ind;
            gem.y = (g == 0) ? colYStart : colYStart + ((this.gemSizeHeight + this.gemSpacing)*g);
            gem.scaleX = gem.scaleY = .9;

            this.allGems.push(gem);
            col.push(gem);
        }

        for(let i = 0; i < this.allGems.length; i++){
            this.allGems[i].name = this.allGems[i].ind;
        }

        return col;
    };

    grab(e){
        // console.log("GRABBING " + e.downX);
        this.isDown = true;

        //LEVEL 0 IS FOR INSTRUCTIONS SECTION
        if(gameData.GAME_LEVEL == 0){
            if(gameData.INTRO_STEP >= 3){
                // this.on("pressup", this.release, this, true);
            } else {
                for(let a1 = 0; a1 < this.allGems.length; a1++){
                    this.allGems[a1].isSelected = false;
                    this.allGems[a1].adj = 0;

                    let x1n1 = e.downX;
                    let y1n1 = e.downY;
                    let x2n1 = this.allGems[a1].x;
                    let y2n1 = this.allGems[a1].y;
                    let intersectionN1 = Math.sqrt( (x2n1-=x1n1)*x2n1 + (y2n1-=y1n1)*y2n1 );

                    //if the distance is below 45px, and the answer block is empty, snap the block to it
                    //then save which answer block it is on and set that answer block to full
                    if(intersectionN1 <= 40){
                        if(gameData.INTRO_STEP == 0 || gameData.INTRO_STEP == 1){
                            if(this.allGems[a1].ind == 6){
                                this.scene.navBar.toggleInstructions("on", "fast");
                                this.scene.tweens.killTweensOf(this.hand);
                                this.hand.alpha = 0;

                                this.lineTopCont.removeAll(true);
                                this.lineBotCont.removeAll(true);

                                gameData.QUESTIONING = true;
                                gameData.GRABBING = true;

                                this.clusters = [];
                                this.lineArr = [];
                                this.circleArr = [];

                                this.scene.navBar.prevQ = 0;
                                this.scene.navBar.factorTxt.text = "0";

                                this.scene.navBar.setListeners("off");
                                this.scene.navBar.toggleAnswer("off");

                                gameData.SELECTED_GEM = this.allGems[a1];
                                this.allGems[a1].scaleX = this.allGems[a1].scaleY = 1.15;

                                if(this.prevGem == null){
                                    this.prevGem = 0;
                                    this.prevGemInd = 99;
                                    gameData.INIT_GRAB = true;
                                }

                                if(this.allGems[a1].ind != 97 && this.allGems[a1].ind != 98 && this.allGems[a1].ind != 99){
                                    this.scene.navBar.toggleInstructions("off", "fast");
                                    this.scene.navBar.createQuestion(1, gameData.SELECTED_GEM.ind);
                                }

                                this.soundInd = this.prevGem;
                                ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[this.soundInd], this.scene);

                                this.createConnection("line",gameData.SELECTED_GEM, this.allGems[a1]);
                            }
                        }
                        if(gameData.INTRO_STEP == 2){
                            if(this.allGems[a1].ind == 97 || this.allGems[a1].ind == 98 || this.allGems[a1].ind == 99){
                                this.scene.navBar.toggleInstructions("on", "fast");
                                this.scene.tweens.killTweensOf(this.hand);
                                this.hand.alpha = 0;

                                this.lineTopCont.removeAll(true);
                                this.lineBotCont.removeAll(true);

                                gameData.QUESTIONING = true;
                                gameData.GRABBING = true;

                                this.clusters = [];
                                this.lineArr = [];
                                this.circleArr = [];

                                this.scene.navBar.prevQ = 0;
                                this.scene.navBar.factorTxt.text = "0";

                                this.scene.navBar.setListeners("off");
                                this.scene.navBar.toggleAnswer("off");

                                gameData.SELECTED_GEM = this.allGems[a1];
                                this.allGems[a1].scaleX = this.allGems[a1].scaleY = 1.15;

                                if(this.prevGem == null){
                                    this.prevGem = 0;
                                    this.prevGemInd = 99;
                                    gameData.INIT_GRAB = true;
                                }

                                this.soundInd = this.prevGem;
                                ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[this.soundInd], this.scene);

                                this.createConnection("line",gameData.SELECTED_GEM, this.allGems[a1]);
                            }
                        }
                    } else {
                        this.allGems[a1].scaleX = this.allGems[a1].scaleY = .9;
                    }
                }
            }
        } else {
            //NORMAL GRABBING FUNCTIONALITY
            this.scene.navBar.toggleInstructions("on", "fast");

            this.lineTopCont.removeAll(true);
            this.lineBotCont.removeAll(true);

            this.clusters = [];
            this.lineArr = [];
            this.circleArr = [];

            this.scene.navBar.prevQ = 0;
            this.scene.navBar.factorTxt.text = "0";

            this.scene.navBar.setListeners("off");
            this.scene.navBar.toggleAnswer("off");

            for(let a = 0; a < this.allGems.length; a++){
                this.allGems[a].isSelected = false;
                this.allGems[a].adj = 0;

                let x1n = e.downX;
                let y1n = e.downY;
                let x2n = this.allGems[a].x;
                let y2n = this.allGems[a].y;
                let intersectionN = Math.sqrt( (x2n-=x1n)*x2n + (y2n-=y1n)*y2n );

                //if the distance is below 45px, and the answer block is empty, snap the block to it
                //then save which answer block it is on and set that answer block to full
                if(intersectionN <= 40){
                    gameData.QUESTIONING = true;
                    gameData.GRABBING = true;
                    gameData.SELECTED_GEM = this.allGems[a];
                    
                    this.allGems[a].scaleX = this.allGems[a].scaleY = 1.15;

                    if(this.prevGem == null){
                        this.prevGem = 0;
                        this.prevGemInd = 99;
                        gameData.INIT_GRAB = true;
                    }

                    if(this.allGems[a].ind != 97 && this.allGems[a].ind != 98 && this.allGems[a].ind != 99){
                        this.scene.navBar.toggleInstructions("off", "fast");
                        this.scene.navBar.createQuestion(1, gameData.SELECTED_GEM.ind);
                    }

                    this.soundInd = this.prevGem;
                    ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[this.soundInd], this.scene);

                    this.createConnection("line",gameData.SELECTED_GEM, this.allGems[a]);
                } else {
                    this.allGems[a].scaleX = this.allGems[a].scaleY = .9;
                }
            }
        }
    };

    move(pointer, localX, localY){
        // if(!gameData.SELECTED_GEM) return;

        let newX = localX - this.scene.mid.x*2;
        let newY = localY - this.scene.mid.y*2;

        if(gameData.GRABBING && gameData.SELECTED_GEM){
            this.scene.navBar.toggleAnswer("off");
            // console.log(this.clusters);

            for(let i = 0; i < this.allGems.length; i++){
                this.allGems[i].scaleX = this.allGems[i].scaleY = .9;
    
                if(this.allGems[i]?.ind === gameData.SELECTED_GEM?.ind){
                    let x1 = newX;
                    let y1 = newY;
                    let x2 = this.allGems[i].x;
                    let y2 = this.allGems[i].y;
                    let intersection = Phaser.Math.Distance.Between(x1, y1, x2, y2);
    
                    let ogx1 = gameData.SELECTED_GEM.x;
                    let ogy1 = gameData.SELECTED_GEM.y;
                    let ogx2 = newX;
                    let ogy2 = newY;
                    let intersection2 = Phaser.Math.Distance.Between(ogx1, ogy1, ogx2, ogy2);
    
                    //if the distance is below 45px, and the answer block is empty, snap the block to it
                    //then save which answer block it is on and set that answer block to full
                    if(intersection <= 44 && intersection2 <= 80){
                        if(this.clusters.indexOf(this.allGems[i]) != -1){
                            // console.log("current = " + Number(this.clusters.indexOf(this.allGems[i])) + " prev = " + this.prevGem);
    
                            if(this.prevGem != Number(this.clusters.indexOf(this.allGems[i]))){
                                while(this.prevGem > Number(this.clusters.indexOf(this.allGems[i]))){
                                    this.lineArr[this.prevGem].destroy();
                                    this.circleArr[this.prevGem].destroy();
                                    this.clusters[this.clusters.length-1].isSelected = false;
    
                                    this.lineArr.pop();
                                    this.circleArr.pop();
                                    this.clusters.pop();
                                    this.prevGem--;
                                }
    
                                this.soundInd = Number(this.clusters.indexOf(this.allGems[i]));
                                if(this.soundInd > 11){
                                    this.soundInd = 11;
                                }
    
                                ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[this.soundInd], this.scene);
                            }
                        } else {
                            // console.log("adding to cluster?")
                            this.clusters.push(this.allGems[i]);
                            this.allGems[i].isSelected = true;
    
                            if(gameData.INIT_GRAB){
                                this.lineTopCont.removeAll(true);
                                this.lineBotCont.removeAll(true);
    
                                this.lineArr = [];
                                this.circleArr = [];
                                gameData.INIT_GRAB = false;
                            } else {
                                //console.log("PLAYING SOUND");
                                this.soundInd = this.prevGem+1;
                                if(this.soundInd > 11){
                                    this.soundInd = 11;
                                }
                                ABCyaPhaser.Audio.playOneShot(gameData.CORRECT_SOUNDS[this.soundInd], this.scene);
                            }
    
                            this.createConnection("line",gameData.SELECTED_GEM, this.allGems[i]);
    
                            this.prevGem = this.clusters.length-1;
                            this.prevGemInd = this.clusters[this.clusters.length-1].randInd;
    
                        }
    
                        gameData.SELECTED_GEM = this.allGems[i];
                        gameData.SELECTED_GEM.scaleX = gameData.SELECTED_GEM.scaleY = 1.15;
                    }
                }
            }
    
            if(gameData.SELECTED_GEM.ind != 97 && gameData.SELECTED_GEM.ind != 98 && gameData.SELECTED_GEM.ind != 99){
                if(this.clusters.length > 0){
                    this.scene.navBar.createQuestion(this.clusters.length, this.clusters[0].ind);
                }
            }
        }
    };

    release(e){
        this.soundInd = 0;
        this.prevGem = null;
        this.isDown = false;

        if(gameData.GAME_LEVEL == 0){
            if(!this.scene.navBar.skip.input.enabled) this.scene.navBar.skip.setEnabled(true);
            
            if(gameData.INTRO_STEP == 1 || gameData.INTRO_STEP == 2){
                if(!gameData.GRABBING) return;
            } else if(gameData.INTRO_STEP == 3){
                this.moveHand("points");
            } else if(gameData.INTRO_STEP == 4){
                this.moveHand("timer");
            } else if(gameData.INTRO_STEP == 5){
                this.destroyLevel(true);
            } else {
                console.log("resetting ui");
                this.setUI(false);
                this.setUI(true);
            }
        } else {
            if(!gameData.GRABBING) {
                if(gameData.SELECTED_GEM) gameData.SELECTED_GEM = null;
                this.scene.navBar.setListeners("on");
                return;
            }
        }

        if(gameData.SELECTED_GEM){
            if(this.clusters.length == 0){
                this.clusters.push(gameData.SELECTED_GEM);
                gameData.SELECTED_GEM.isSelected = true;
            }

            if(this.clusters.length > 0){
                if(gameData.SELECTED_GEM.ind != 98 && gameData.SELECTED_GEM.ind != 99 && gameData.SELECTED_GEM.ind != 97){
                    //console.log("CREATING QUESTIONS?!?!");
                    this.scene.navBar.toggleInstructions("off");
                    this.scene.navBar.setListeners("on");

                    if(this.lineArr.length > this.clusters.length){
                        while(this.lineArr.length > this.clusters.length){
                            this.lineArr[this.lineArr.length-1].destroy();
                            this.circleArr[this.circleArr.length-1].destroy();

                            this.lineArr.pop();
                            this.circleArr.pop();
                        }
                    }

                    this.scene.navBar.createQuestion(this.clusters.length, this.clusters[0].ind);
                    this.scene.navBar.createAnswers(this.clusters.length, this.clusters[0].ind);
                    this.prevGemInd = gameData.SELECTED_GEM.randInd;
                } else {
                    // console.log("SPECIAL CLICKED");
                    gameData.SPECIAL_GEM = true;

                    this.prevGemInd = gameData.SELECTED_GEM.randInd;

                    this.boomBoom(gameData.SELECTED_GEM);

                    gameData.GRABBING = false;
                    gameData.QUESTIONING = false;
                }
            }

            gameData.SELECTED_GEM.scaleX = gameData.SELECTED_GEM.scaleY = .9;
        }

        this.lineArr = [];
        this.circleArr = [];

        gameData.INIT_GRAB = false;
        gameData.GRABBING = false;
    };

    updateGrid(adj) {
        let adjust = adj | 0;

        this.lineTopCont.removeAll(true);
        this.lineBotCont.removeAll(true);

        //Loop through each gem in each column and check if the gem is selected.
        //If selected, loop through that column backwards starting with that index and
        //add +1 to the previous gems adj value.
        for (let q = 0; q < this.gems.length; q++) {
            for (let q2 = 0; q2 < this.gems[q].length; q2++) {
                if (this.gems[q][q2].isSelected) {
                    for (let q3 = q2; q3 >= 0; q3--) {
                        this.gems[q][q3].adj++;
                    }
                }
            }
        }

        //loop through the clusters and set index to the front. stop animation. remove them from column arrays
        for(let c = 0; c < this.clusters.length; c++) {
            this.cont.bringToTop(this.clusters[c]);
            this.destroyGem("stop", this.clusters[c]);

            for (let w = 0; w < this.gems.length; w++) {
                for (let w2 = 0; w2 < this.gems[w].length; w2++) {
                    if (this.gems[w][w2].randInd == this.clusters[c].randInd) {
                        this.gems[w].splice(w2, 1);
                    }
                }
            }
        }

        //tween the remaining gems in the column down but the adj value then reset adj value back to 0
        for(let g = 0; g < this.gems.length; g++) {
            for (let g2 = 0; g2 < this.gems[g].length; g2++) {
                if(g == this.gems.length-1){
                    ABCyaPhaser.Tweens.addTween(this.gems[g][g2], 500, {y: this.gems[g][g2].y + (this.gemSizeHeight * this.gems[g][g2].adj)}, Phaser.Math.Easing.Cubic.In, ()=>{
                        if(g2 == this.gems[g].length-1) this.playSound();
                    });
                }
                
                ABCyaPhaser.Tweens.addTween(this.gems[g][g2], 500, {y: this.gems[g][g2].y + (this.gemSizeHeight * this.gems[g][g2].adj)}, Phaser.Math.Easing.Cubic.In)
                this.gems[g][g2].adj = 0;
            }
        }

        this.scene.time.delayedCall(adjust, ()=>{this.fillGrid();});
    };

    fillGrid(){
        let randGem;
        let colYStart = this.gemSizeHeight;

        //console.log("CLUSTER LEN = " + this.clusters.length);
        //remove them from the allGems array
        for(let d2 = 0; d2 < this.allGems.length; d2++){
            for(let c2 = 0; c2 < this.clusters.length; c2++){
                if(this.allGems[d2] == this.clusters[c2]){
                    this.allGems.splice(d2, 1);
                }
            }
        }

        //random gem cleanup
        for(let d = this.allGems.length-1; d >= 0; d--){
            if(!this.allGems[d].scene) 
            {
                this.allGems[d].destroy();
                this.allGems.splice(d, 1);
            }
        }

        for(let g = 0; g < this.gems.length; g++) {
            while(this.gems[g].length < 8){
                if(gameData.GAME_LEVEL == 0 || gameData.GAME_LEVEL == 1){
                    randGem = Phaser.Math.Between(2,5);
                }
                if(gameData.GAME_LEVEL == 2){
                    randGem = Phaser.Math.Between(3,6);
                }
                if(gameData.GAME_LEVEL == 3){
                    randGem = Phaser.Math.Between(4,7);
                }
                if(gameData.GAME_LEVEL == 4){
                    randGem = Phaser.Math.Between(5,8);
                }
                if(gameData.GAME_LEVEL == 5){
                    randGem = Phaser.Math.Between(6,9);
                }
                if(gameData.GAME_LEVEL == 6){
                    randGem = Phaser.Math.Between(7,10);
                }
                if(gameData.GAME_LEVEL == 7){
                    randGem = Phaser.Math.Between(8,11);
                }
                if(gameData.GAME_LEVEL == 8){
                    randGem = Phaser.Math.Between(9,12);
                }

                let gem = new Gem(this.scene, this.cont, randGem);
                this.gemsToAdj++;

                this.cont.moveTo(gem, 1);
                ABCyaPhaser.Tweens.addTween(gem, 500, {y: colYStart + (this.gemSizeHeight * (8-this.gems[g].length))}, Phaser.Math.Easing.Cubic.In, ()=>{
                    this.scene.time.delayedCall(50, ()=>{this.adjGems();});
                });

                gem.scaleX = gem.scaleY = .9;
                gem.x = this.gemSizeWidth/1.25 + (this.gemSizeWidth + this.gemSpacing)*g;

                this.allGems.unshift(gem);
                this.gems[g].unshift(gem);
            }
        }

        for(let i = 0; i < this.allGems.length; i++){
            this.allGems[i].isSelected = false;
            this.allGems[i].adj = 0;
            this.allGems[i].randInd = i;
        }
        gameData.SELECTED_GEM = null;
        this.clusters = [];
    };

    adjGems(){
        this.adjInd++;
        //console.log("adj = " + this.adjInd);
        //console.log(gameData.SPECIAL_GEM);

        let colXStartAdj = this.gemSizeWidth/1.25;
        let colYStartAdj = this.gemSizeHeight*2 - this.gemSpacing*3;

        if(gameData.SPECIAL_GEM){
            if(this.gemsToAdj == this.adjInd){
                // console.log("ADJUSTING SPECIAL GEMS!");
                this.adjInd = 0;
                this.gemsToAdj = 0;

                this.scene.navBar.toggleInstructions("on");
                this.scene.navBar.setListeners("on");
                this.setUI(true);

                for(let a = 0; a < this.gems.length; a++) {
                    for (let g2 = 0; g2 < this.gems[a].length; g2++) {
                        this.gems[a][g2].x = (a == 0) ? colXStartAdj : colXStartAdj + (this.gemSizeWidth + this.gemSpacing)*a;
                        this.gems[a][g2].y = (g2 == 0) ? colYStartAdj : colYStartAdj + ((this.gemSizeHeight + this.gemSpacing)*g2);
                    }
                }

                gameData.SPECIAL_GEM = false;
            }
        }
    };

    boomBoom(obj){
        let tempXMin = [];
        let tempXMax = [];
        let tempYMin = [];
        let tempYMax = [];
        let explodeArr = [];

        this.scene.navBar.toggleInstructions("off", "fast");
        this.scene.navBar.setListeners("off");
        this.setUI(false);

        ABCyaLib.Storage.saveObject("score", 1);

        if(obj.ind == 99){
            ABCyaPhaser.Audio.playOneShot("clock_bonus", this.scene);
            this.scene.navBar.setTimer("replenish", .1, false);
            this.createPrompt(gameData.SELECTED_GEM);

            this.cont.moveTo(obj, this.cont.list.length-1)

            this.scene.tweens.timeline({
                targets: obj,
                duration:500,
                onComplete:()=>{this.boomBoomDone();},

                tweens: [
                    {scale:1.5, x:this.scene.mid.x - this.gemSizeWidth/2, y:this.scene.mid.y, ease:Phaser.Math.Easing.Sine.Out},
                    {scale:.3, x:this.scene.mid.x - 50, y:this.gemSizeHeight/2, ease:Phaser.Math.Easing.Sine.In},
                ]
            });
        }
        if(obj.ind == 98){
            ABCyaPhaser.Audio.playOneShot("bomb_bonus", this.scene);
            for(let i = 0; i < this.allGems.length; i++){
                let x1 = obj.x;
                let y1 = obj.y;
                let x2 = this.allGems[i].x;
                let y2 = this.allGems[i].y;
                let intersection = Math.sqrt( (x2-=x1)*x2 + (y2-=y1)*y2 );

                //select all gems within a small radius
                if(intersection <= 140){
                    if(this.clusters.indexOf(this.allGems[i]) == -1){
                        this.clusters.push(this.allGems[i]);
                    }

                    this.allGems[i].isSelected = true;
                }

                //Make the close gems blow outwards
                if(intersection <= 200 && intersection > 160){
                    explodeArr.push(this.allGems[i]);
                }
            }

            //remove them from the allGems array
            for(let d2 = 0; d2 < this.allGems.length; d2++){
                for(let c2 = 0; c2 < this.clusters.length; c2++){
                    if(this.allGems[d2] == this.clusters[c2]){
                        this.allGems.splice(d2, 1);
                    }
                }
            }

            //esplode them!
            // console.log(this.clusters.length);
            for(let v = 0; v < this.clusters.length; v++){
                if(this.clusters[v].ind == 98 && this.clusters[v] == gameData.SELECTED_GEM){
                    this.clusters[v].explode(true);
                } else {
                    this.clusters[v].explode();
                }
            }

            //animate the far out gems
            this.aftershock(explodeArr, obj);
        }
        if(obj.ind == 97){
            ABCyaPhaser.Audio.playOneShot("Dynamite", this.scene);
            //COLUMNS
            for(let dy = 0; dy < this.allGems.length; dy++){
                if(this.allGems[dy].x == obj.x && this.allGems[dy].y != obj.y){
                    this.clusters.push(this.allGems[dy]);

                    if(this.allGems[dy].y < obj.y){
                        tempYMin.push(this.allGems[dy]);
                    } else {
                        tempYMax.push(this.allGems[dy]);
                    }

                    this.allGems[dy].isSelected = true;
                }
            }

            //ROWS
            for(let dx = 0; dx < this.allGems.length; dx++){
                if(this.allGems[dx].y == obj.y && this.allGems[dx].x != obj.x){
                    this.clusters.push(this.allGems[dx]);

                    if(this.allGems[dx].x < obj.x){
                        tempXMin.push(this.allGems[dx]);
                    } else {
                        tempXMax.push(this.allGems[dx]);
                    }

                    this.allGems[dx].isSelected = true;
                }
            }

            for(let d = 0; d < this.allGems.length; d++){
                if(this.allGems[d] == obj){
                    obj.explode();
                    this.allGems.splice(d, 1);
                }
            }

            tempXMin.sort(this.dynamicSort("-x"));
            tempXMax.sort(this.dynamicSort("x"));
            tempYMin.sort(this.dynamicSort("-y"));
            tempYMax.sort(this.dynamicSort("y"));

            for(let tx = 0; tx < tempXMin.length; tx++){
                this.scene.time.delayedCall(100*tx, ()=>{tempXMin[tx].explode();});
            }
            for(let tx2 = 0; tx2 < tempXMax.length; tx2++){
                this.scene.time.delayedCall(100*tx2, ()=>{tempXMax[tx2].explode();});
            }
            for(let ty = 0; ty < tempYMin.length; ty++){
                this.scene.time.delayedCall(100*ty, ()=>{tempYMin[ty].explode();});
            }
            for(let ty2 = 0; ty2 < tempYMax.length; ty2++){
                this.scene.time.delayedCall(100*ty2, ()=>{tempYMax[ty2].explode();});
            }

            this.scene.time.delayedCall(500, ()=>{this.boomBoomDone();});
        }

        this.lineTopCont.removeAll(true);
        this.lineBotCont.removeAll(true);
        
        this.lineArr = [];
        this.circleArr = [];
    };

    dynamicSort(property) {
        let sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }

    aftershock(gems, obj){
        let expArr = gems;
        let adj;

        for(let e = 0; e < expArr.length; e++){
            let oldX = expArr[e].x;
            let oldY = expArr[e].y;

            if(expArr[e].x < obj.x && expArr[e].y == obj.y){
                adj = {adjX:-30, adjY:0};
            }
            if(expArr[e].x > obj.x && expArr[e].y == obj.y){
                adj = {adjX:30, adjY:0};
            }
            if(expArr[e].y < obj.y && expArr[e].x == obj.x){
                adj = {adjX:0, adjY:-30};
            }
            if(expArr[e].y > obj.y && expArr[e].x == obj.x){
                adj = {adjX:0, adjY:30};
            }

            if(expArr[e].y > obj.y && expArr[e].x > obj.x){
                adj = {adjX:30, adjY:30};
            }
            if(expArr[e].y < obj.y && expArr[e].x < obj.x){
                adj = {adjX:-30, adjY:-30};
            }
            if(expArr[e].y > obj.y && expArr[e].x < obj.x){
                adj = {adjX:-30, adjY:30};
            }
            if(expArr[e].y < obj.y && expArr[e].x > obj.x){
                adj = {adjX:30, adjY:-30};
            }

            let newAdjX = oldX + adj.adjX;
            let newAdjY = oldY + adj.adjY;

            if(e == expArr.length-1){
                this.scene.tweens.timeline({
                    targets: expArr[e],
                    duration:250,
                    onComplete:()=>{this.boomBoomDone();},
    
                    tweens: [
                        {x:newAdjX, y:newAdjY, ease:Phaser.Math.Easing.Sine.Out},
                        {x:oldX, y:oldY, ease:Phaser.Math.Easing.Sine.In},
                    ]
                });
            } else {
                this.scene.tweens.timeline({
                    targets: expArr[e],
                    duration:250,
    
                    tweens: [
                        {x:newAdjX, y:newAdjY, ease:Phaser.Math.Easing.Sine.Out},
                        {x:oldX, y:oldY, ease:Phaser.Math.Easing.Sine.In},
                    ]
                });
            }
        }
    };

    boomBoomDone(){
        this.updateGrid(100);
        this.destroyGem("final", gameData.SELECTED_GEM);

        this.scene.navBar.setScore(50, false, true);

        if(gameData.GAME_LEVEL == 0){
            this.moveHand("score");
        }
    };

    wiggle(num, spd){
        let n = num;
        let s = spd;
        //console.log("wiggling for " + n + " and speed = " + s);

        if(n > 0){
            this.scene.time.delayedCall(s*4, ()=>{this.wiggle(n-1, s);});
        } else {
            this.clusters = [];
            this.scene.navBar.toggleInstructions("on");
            this.scene.navBar.setListeners("on");
            this.setUI(true);
            gameData.QUESTIONING = false;

            if(gameData.GAME_LEVEL == 0){
                this.handTween?.stop();
                this.scene.tweens.killTweensOf(this.hand);
                this.dCall?.destroy();

                this.playInstructions();
            }
        }

        for(let i = 0; i < this.clusters.length; i++){
            this.scene.tweens.timeline({
                targets: this.clusters[i],
                ease:Phaser.Math.Easing.Linear,
                duration:s,

                tweens: [
                    {angle:30},
                    {angle:0},
                    {angle:-30},
                    {angle:0},
                ]
            });
        }
    };

    score(type){
        if(type == "+"){
            let cNum = this.clusters.length;

            for(let c = 0; c < this.clusters.length; c++){
                this.cont.bringToTop(this.clusters[c]);

                if(c == this.clusters.length-1){
                    this.updateGrid(100*c);
                    //console.log("LAST SCORE and len = " + len);
                    this.scene.navBar.clusterLen = this.clusters.length;

                    ABCyaPhaser.Tweens.addTween(this.clusters[c], 500, {delay:100*c, scale:1.5, x:this.scene.mid.x - this.gemSizeWidth/2, y:this.scene.mid.y}, Phaser.Math.Easing.Sine.Out, (tween)=>{
                        this.scene.navBar.setScore(cNum);

                        ABCyaPhaser.Tweens.addTween(tween.targets, 500, {scale:.3, x:575, y:this.gemSizeHeight/2}, Phaser.Math.Easing.Sine.In, ()=>{
                            this.destroyGem("final", tween.targets);
                        });
                    });
                } else {
                    ABCyaPhaser.Tweens.addTween(this.clusters[c], 500, {delay:100*c, scale:1.5, x:this.scene.mid.x - this.gemSizeWidth/2, y:this.scene.mid.y}, Phaser.Math.Easing.Sine.Out, (tween)=>{
                        ABCyaPhaser.Tweens.addTween(tween.targets, 500, {scale:.3, x:575, y:this.gemSizeHeight/2}, Phaser.Math.Easing.Sine.In, ()=>{
                            this.destroyGem("clear", tween.targets);
                        });
                    });
                }

                if(this.bgShade) this.cont.moveTo(this.clusters[c], 1);
            }

            if(gameData.GAME_LEVEL == 0){
                for(let a = 0; a < this.allGems.length; a++) {
                    if (this.allGems[a].ind == 6 && this.clusters.indexOf(this.allGems[a]) == -1) {
                        this.cont.moveTo(this.allGems[a], 5);
                    }
                }
            }
        }
        if(type == "-"){
            for(let g = 0; g < this.gems.length; g++) {
                for (let g2 = 0; g2 < this.gems[g].length; g2++) {
                    this.gems[g][g2].adj = 0;
                    this.gems[g][g2].isSelected = false;
                }
            }

            this.lineTopCont.removeAll(true);
            this.lineBotCont.removeAll(true);
        }
    };

    createSpecialGem(amount){
        let specialAmnt;

        if(amount >= 5 && amount < 10){
            specialAmnt = 1;
        }
        if(amount >= 10 && amount < 15){
            specialAmnt = 2;
        }
        if(amount >= 15 && amount < 20){
            specialAmnt = 3;
        }
        if(amount >= 20){
            specialAmnt = 4;
        }

        for (let g2 = 0; g2 < specialAmnt; g2++) {
            let randGem = Phaser.Math.Between(0, this.allGems.length-1);
            while(this.allGems[randGem].scene == null)
            {
                // for some reason, gems that are destroyed are sometimes still in the allGems array;
                // S.R. hasn't been able to figure out why or how to fix it, so these bandaid fixes prevent issues
                // if the random gem is a destroyed one, the game logic stops because the game is waiting for the special gem to spawn before reactivating,
                // so by making sure the random gem isn't a destroyed one, we prevent that issue
                randGem = Phaser.Math.Between(0, this.allGems.length-1);
            }
            this.allGems[randGem].changeSpecial(Phaser.Math.Between(97,99));
        }
    };

    createConnection(type, obj1, obj2){
        let iCont = this.scene.add.container();
        let iCont2 = this.scene.add.container();

        if(type == "line"){
            //console.log("creating line at " + obj1 + " " + obj2);

            let circle1 = ABCyaPhaser.Graphics.addCircle(obj1.x, obj1.y, 5, "0xFFFFFF", iCont);
            let circle3 = ABCyaPhaser.Graphics.addCircle(obj2.x, obj2.y, 5, "0xFFFFFF", iCont);
            let line2 = this.scene.add.line(0, 0, obj1.x, obj1.y, obj2.x, obj2.y, "0xFFFFFF").setOrigin(0, 0).setLineWidth(2);

            let circle2 = ABCyaPhaser.Graphics.addCircle(obj1.x, obj1.y, 10, "0x5A6EFF", iCont2);
            let circle4 = ABCyaPhaser.Graphics.addCircle(obj2.x, obj2.y, 10, "0x5A6EFF", iCont2);
            let line = this.scene.add.line(0, 0, obj1.x, obj1.y, obj2.x, obj2.y, "0x5A6EFF").setOrigin(0, 0).setLineWidth(7);

            iCont.add(line2);
            iCont2.add(line);
        }

        if(type == "circle"){
            //console.log("creating circle at " + obj1.x + " " + obj2.x);
            let c1 = ABCyaPhaser.Graphics.addCircle(obj1.x, obj1.y, 5, "0xFFFFFF", iCont);
            let c2 = ABCyaPhaser.Graphics.addCircle(obj1.x, obj1.y, 10, "0xFFFFFF", iCont2);

            this.lineTopCont.add(iCont);
            this.lineBotCont.add(iCont2);

            this.lineArr.push(iCont);
            this.circleArr.push(iCont2);
        }

        this.lineTopCont.add(iCont);
        this.lineBotCont.add(iCont2);

        this.lineArr.push(iCont);
        this.circleArr.push(iCont2);
    };

    playSound(isEnd){
        if(isEnd){
            ABCyaPhaser.Audio.playOneShot("Level_End_Explosion", this.scene);
        } else {
            ABCyaPhaser.Audio.playOneShot("gem_fall", this.scene);
        }
    };

    createPrompt(){
        if(this.prompt) this.destroyPrompt();
        
        this.prompt = ABCyaPhaser.Text.addText(0, 0, 65, "0xFFFFFF", gameData.GAME_FONTS[1], "Time Increased!", this).setStroke("#BA6222", 4).setDepth(7);

        this.prompt.x = this.scene.mid.x;
        this.prompt.y = this.scene.mid.y;
        this.prompt.scaleX = this.prompt.scaleY = 0;
        this.prompt.alpha = 0;

        ABCyaPhaser.Tweens.addTween(this.prompt, 1000, {scale:1, alpha:1}, Phaser.Math.Easing.Back.Out, ()=>{
            this.hidePrompt();
        });
    };

    hidePrompt(){
        this.scene.tweens.killTweensOf(this.prompt);
        ABCyaPhaser.Tweens.addTween(this.prompt, 1000, {delay:500, scale:0, alpha:0}, Phaser.Math.Easing.Back.In, ()=>{
            this.destroyPrompt();
        });
    };

    destroyPrompt(){
        this.scene.tweens.killTweensOf(this.prompt);
        this.prompt.destroy();
        this.prompt = null;
    };

    destroyColumns(col, type){
        //console.log("destroying the columns");
        if(type == "inOut"){
            for (let g = 0; g < 4; g++) {
                this.scene.time.delayedCall(250*g, ()=>{this.playSound(true);});

                if(col == 7 && g == 3){
                    //console.log("LAST DESTROYED = " + gameData.GAME_END);
                    if(gameData.GAME_END){
                        this.scene.time.delayedCall(250*g, ()=>{ if(this.gems[col][g+4]) this.gems[col][g+4].explode(); });
                    } else {
                        //console.log("resetting level");
                        this.scene.time.delayedCall(250*g, ()=>{
                            if(this.gems[col][g+4]) this.gems[col][g+4].explode();

                            if(g >= 3) this.scene.time.delayedCall(150, ()=>{ this.createLevel(); });
                        });
                    }
                } else {
                    this.scene.time.delayedCall(250*g, ()=>{ if(this.gems[col][g+4]) this.gems[col][g+4].explode(); });
                }
                
                this.scene.time.delayedCall(250*g, ()=>{ if(this.gems[col][8-(5+g)]) this.gems[col][8-(5+g)].explode(); });
            }
        }

        if(type == "down"){
            for (let g2 = 0; g2 < this.gems.length; g2++) {
                this.scene.time.delayedCall(100*g2, ()=>{if(this.gems[col][g2]) this.gems[col][g2].explode();});
            }
        }
    };

    checkForSpecial(){
        if(this.clusters > 0){
            for(let d = 0; d < this.clusters.length; d++){
                this.clusters[d].isSelected = false;
            }

            this.clusters = [];
        }

        for(let a = 0; a < this.allGems.length; a++){
            if(this.allGems[a].ind > 90){
                this.clusters.push(this.allGems[a]);
            }
        }

        if(this.clusters.length > 0){
            for(let c = 0; c < this.clusters.length; c++){
                if(this.clusters[c] == null) continue;
                this.cont.moveTo(this.clusters[c], this.cont.list.length - 1);

                if(c == this.clusters.length-1){
                    this.scene.navBar.clusterLen = this.clusters.length;

                    ABCyaPhaser.Tweens.addTween(this.clusters[c], 500, {delay:100*c, scale:1.5, x:this.scene.mid.x - this.gemSizeWidth/2, y:this.scene.mid.y}, Phaser.Math.Easing.Sine.Out, ()=>{
                        this.scene.navBar.setScore(this.clusters.length, true);

                        if(this.clusters[c] != null && this.clusters[c].scene){
                            ABCyaPhaser.Tweens.addTween(this.clusters[c], 500, {scale:.3, x:575, y:this.gemSizeHeight/2}, Phaser.Math.Easing.Linear, ()=>{
                                this.destroyGem("final", this.clusters[c]);
    
                                this.scene.time.delayedCall(200, ()=>{this.destroyLevel();});
                            });
                        }
                    });
                } else {
                    ABCyaPhaser.Tweens.addTween(this.clusters[c], 500, {delay:100*c, scale:1.5, x:this.scene.mid.x - this.gemSizeWidth/2, y:this.scene.mid.y}, Phaser.Math.Easing.Sine.Out, ()=>{
                        if(this.clusters[c] == null || this.clusters[c].scene == null) return;
                        ABCyaPhaser.Tweens.addTween(this.clusters[c], 500, {scale:.3, x:575, y:this.gemSizeHeight/2}, Phaser.Math.Easing.Sine.In, ()=>{
                            this.destroyGem("clear", this.clusters[c]);
                        });
                    });
                }
            }
        } else {
            this.destroyLevel();
        }
    };

    destroyLevel(isIntro){
        if(isIntro){
            this.stopTimerDelayedCall?.remove();
            this.handTween?.stop();
            this.scene.tweens.killTweensOf(this.hand);
            this.dCall?.destroy();

            this.scene.navBar.skip.destroy();
            this.scene.navBar.skip = null;

            gameData.GAME_LEVEL++;
            gameData.INTRO_STEP = 6;

            ABCyaPhaser.Tweens.addTween(this.hand, 500, {scale:0}, Phaser.Math.Easing.Back.In, ()=>{this.hand.destroy();});
            ABCyaPhaser.Tweens.addTween(this.bgShade, 500, {alpha:0}, Phaser.Math.Easing.Linear, ()=>{
                this.bgShade.clear();
                this.bgShade.destroy();
                this.bgShade = null;
            });
            ABCyaPhaser.Tweens.addTween(this.instructionsCont, 500, {scale:0}, Phaser.Math.Easing.Back.In, ()=>{
                this.instructionsCont.removeAll(true);
                this.instructionsCont.destroy();
                this.instructionsCont = null;
            });

            this.scene.navBar.levelBanner("in");
            this.scene.navBar.setTimer("replenish", 1);

            this.scene.navBar.toggleInstructions("on", "fast");

            this.lineTopCont.removeAll(true);
            this.lineBotCont.removeAll(true);

            gameData.QUESTIONING = true;
            gameData.GRABBING = true;

            this.clusters = [];
            this.lineArr = [];
            this.circleArr = [];
        }
        for (let g = 0; g < this.gems.length; g++) {
            this.destroyColumns(g, "inOut");
        }
    };

    destroyInstructions(){
        // this.handTween?.stop();
        // this.scene.tweens.killTweensOf(this.hand);
        // this.dCall?.destroy();

        this.bgShade.clear();
        this.bgShade.destroy();
        this.prompt?.destroy();
        this.instructionsCont.removeAll(true);
        this.instructionsCont.destroy();
        this.hand.destroy();
        this.removeAll();

        this.instructionsCont = null;
        this.instructions = null;
        this.hand = null;
        this.bgShade = null;
        this.prompt = null;
    };

    destroyGem(type, obj){
        // console.log(obj);
        //Destroy the gem
        if(type == "clear" || type == "final"){
            if(this.clusters.indexOf(obj) != -1){
                this.clusters.splice(this.clusters.indexOf(obj), 1);
            }
            if(this.allGems.indexOf(obj) != -1){
                //console.log("removing obj from all gems");
                this.allGems.splice(this.allGems.indexOf(obj), 1);
            }

            // console.log(this.gems, this.gems.indexOf(obj));
            // this.gems.forEach(gem => {
            //     // console.log(gem.indexOf(obj));
            //     gem.splice(gem.indexOf(obj), 1);
            // });

            if(obj){
                Array.isArray(obj) ? obj[0].destroy() : obj.destroy();
                obj[0] = null;
                obj = null;
            }
        }

        if(type == "stop"){
            obj.stopMovement();
        }
    };
}